import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { EmploymentVerificationControl } from "./EmploymentVerificationControl";
import { EmploymentVerificationSummaryControl } from "./EmploymentVerificationSummaryControl";

function EmploymentVerificationControlInternal(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <EmploymentVerificationSummaryControl {...props} />;
  }

  return <EmploymentVerificationControl {...props} />;
}

export const EmploymentVerificationControlRenderer =
  withJsonFormsArrayControlProps(EmploymentVerificationControlInternal);
